export default __webpack_public_path__ + "static/media/1_0048.34262376.webp";